import React from 'react';

/**
 * Last line of defence: if any page throws while rendering, show a readable
 * message and a way home instead of a blank screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error('Render error:', error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="page" data-testid="render-error">
        <section className="band center" style={{ background: 'var(--bg)' }}>
          <div className="wrap narrow">
            <h1 className="display">Something didn&rsquo;t load.</h1>
            <p className="sub">Please refresh the page. If this keeps happening, email <a href="mailto:karla@inner-hq.com">karla@inner-hq.com</a>.</p>
            <div className="cta-wrap c"><a className="cta" href="/">Return to The Performance Reset</a></div>
          </div>
        </section>
      </div>
    );
  }
}
